/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   alwaysReducer that always returns the given argument
 */

export const alwaysReducer =
  <Payload>(payload: Payload) =>
  (state?: any, action?: any) =>
    payload
